export default "/assets/images/filter-01.b27272868503982f.svg";